var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/takaku_logo.svg"),"alt":"高く売れるドットコム"}}),_vm._v(" "),(_vm.templateType === 'info')?_c('h1',[_vm._v("お送りいただいた商品の本査定額を"),_c('br',{staticClass:"sp_only"}),_vm._v("お知らせします。\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d6e7618","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBar.vue
// module id = null
// module chunks = 